import axios from 'axios';
import UniversalCookie from 'universal-cookie';
import { APIURL } from '/config.js';
import { HEADERS, CLIENT_PLATFORM_VALUE } from './constants.js';

const cookies = new UniversalCookie();
const cookieToken = () => cookies.get('token');

const axiosInstance = axios.create({
  baseURL: APIURL,
});

/**
 * Builds authentication headers for the request
 * @param {Object} request - Axios request object
 * @returns {Object} Headers object with authentication and platform info
 */
const buildAuthHeaders = request => {
  const headers = {
    [HEADERS.CLIENT_PLATFORM]: CLIENT_PLATFORM_VALUE,
  };

  const token = cookieToken();
  if (token) {
    headers[HEADERS.ACCESS_TOKEN] = token;
  } else if (window.apiKey) {
    headers[HEADERS.API_KEY] = window.apiKey;
  }

  return headers;
};

/**
 * Adds organization ID header if available
 * @param {Object} request - Axios request object
 */
const addOrganizationHeader = request => {
  const organizationId = localStorage.getItem('organizationId');
  if (organizationId) {
    request.headers[HEADERS.ORGANIZATION_ID] = organizationId;
  }
};

/**
 * Request interceptor handler
 * Adds authentication headers and organization ID to all requests
 */
const requestHandler = request => {
  const authHeaders = buildAuthHeaders(request);
  Object.assign(request.headers, authHeaders);
  addOrganizationHeader(request);
  return request;
};

const responseHandler = response => {
  return response;
};

const errorHandler = error => {
  console.error('API Error:', error);

  if (error.response) {
    throw error.response.data;
  }

  if (error.request) {
    throw new Error('No response received from server');
  }

  throw error;
};

axiosInstance.interceptors.request.use(requestHandler);
axiosInstance.interceptors.response.use(responseHandler, errorHandler);

export { APIURL, axiosInstance as axios };
